import { render, staticRenderFns } from "./app-table.vue?vue&type=template&id=594d1919&scoped=true"
import script from "./app-table.vue?vue&type=script&lang=js"
export * from "./app-table.vue?vue&type=script&lang=js"
import style0 from "./app-table.vue?vue&type=style&index=0&id=594d1919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d1919",
  null
  
)

export default component.exports